import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  typography: {
    fontFamily: "Roboto, sans-serif", // This will only apply within the theme
    htmlFontSize: 10,
  },
  palette: {
    primary: {
      main: '#2196F3',
    },
    secondary: {
      main: '#F1605E',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
